import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../../Actions/AllAction';
import BillPostingSettings from '../../Components/BillPostingSettings';
import '../../Styles/BillPostingSettings.scss';

/**
 * Bill Posting Settings Page Component
 * Standalone page for managing PMS integration settings
 */
class BillPostingSettingsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    componentDidMount() {
        // Set active link for navigation
        this.props.handleActiveLink("settings_module", "bill_posting_settings");
        
        // Set page title
        document.title = "Bill Posting Settings - POS Core";
    }

    render() {
        const { t } = this.props;
        
        return (
            <div className="homepagecontainer connectheader">
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <BillPostingSettings 
                                t={t} 
                                detectChangesIndividualTab={() => {}} 
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        access_token: globalState.mainReducerData.access_token,
        roleWisePermission: globalState.mainReducerData.roleWisePermission
    };
};

export default connect(mapStateToProps, { 
    loaderStateTrue, 
    loaderStateFalse, 
    handleActiveLink 
})(withRouter(BillPostingSettingsPage));
